<template>
  <div class="discovery-item discovery-item-single" role="button">
    <itemImage :item="item" size="large"/>
    <item-tooltip :item="item" />
  </div>
</template>

<script>
import ItemTooltip from '@/components/ui/ItemTooltip.vue';
import ItemImage from '@/components/ui/ItemImage.vue';

export default {
  name: 'SingleItem',
  data() {
    return {
      bgColor: null,
    };
  },
  components: {
    ItemTooltip,
    ItemImage,
  },
  props: {
    item: {},
  },
};
</script>
